module.exports = __webpack_public_path__ + "img/location-not-found.c9d04b25.webp";